import React from 'react';
import ContentfulRichText from 'components/RichText/ContentfulRichText';
import ContentfulAccordion from 'components/Contentful/ContentfulAccordion';
import RichTextCta from '../components/RichTextCta';
import RichTextBlockQuote from '../components/RichTextBlockQuote';
import RichTextConversionPanel from '../components/RichTextConversionPanel';
import RichTextInlineMarketingForm from '../components/RichTextInlineMarketingForm';
import RichTextEmbed from '../components/RichTextEmbed';
import RichTextImageMp4 from '../components/RichTextImageMp4';
import RichTextVideo from '../components/RichTextVideo';
import RichTextTable from '../components/RichTextTable';
import RichTextAd from '../components/RichTextAd';

const optionsEmbeds = (node, alignDesktop, alignMobile, dataPosition, formType) => {
  const type = node?.data?.target?.__typename;
  const component = { ...node?.data };
  const fields = component.target;
  delete component.target;
  component.fields = fields;

  if (type === 'ContentfulInlineMarketingForm') {
    return (
      <RichTextInlineMarketingForm {...component} dataPosition={dataPosition} formType={formType} />
    );
  }

  if (type === 'ContentfulCallToAction') {
    return (
      <RichTextCta
        {...component}
        alignDesktop={alignDesktop}
        alignMobile={alignMobile}
        dataPosition={dataPosition}
        formType={formType}
      />
    );
  }

  if (type === 'ContentfulBlockQuote') {
    return <RichTextBlockQuote {...component} />;
  }

  if (type === 'ContentfulConversionPanel') {
    return (
      <RichTextConversionPanel {...component} dataPosition={dataPosition} formType={formType} />
    );
  }

  if (type === 'ContentfulWistiaVideo') {
    return <RichTextVideo {...component} />;
  }

  if (type === 'ContentfulEmbedCode') {
    return <RichTextEmbed {...component} />;
  }

  if (type === 'ContentfulImage') {
    return (
      <RichTextImageMp4 alignDesktop={alignDesktop} alignMobile={alignMobile} {...component} />
    );
  }

  if (type === 'ContentfulTable') {
    return <RichTextTable {...component} />;
  }

  if (type === 'ContentfulAd') {
    return <RichTextAd {...component} />;
  }

  if (type === 'ContentfulFaq') {
    return <ContentfulAccordion {...component?.fields} />;
  }

  if (type === 'ContentfulRichText') {
    return <ContentfulRichText richText={component?.fields} />;
  }

  return null;
};

export default optionsEmbeds;
